import { ContactInfoProcessStep, ExpressCheckoutProcessStep } from './progressStepsSlice';

export const getCheckoutPage = (isExpressCheckout) =>
  isExpressCheckout ? ContactInfoProcessStep.ExpressCheckout : ContactInfoProcessStep.PRO.OrderReview;

export const getSelfInstallPageForSequential = (isExpressCheckout) =>
  isExpressCheckout ? ContactInfoProcessStep.ExpressCheckout : ContactInfoProcessStep.Shipping;

export const getExpressCheckoutStep = (totalDueToday, isPaymentDetailsAvailable, isProSetup) => {
  let updateView = ExpressCheckoutProcessStep.ExpressTOS;

  if (totalDueToday > 0 && !isPaymentDetailsAvailable) {
    updateView = ExpressCheckoutProcessStep.Payment;
  } else if (isProSetup) {
    updateView = ExpressCheckoutProcessStep.Appointment;
  }

  return updateView;
};
